
import appicon from "assets/icon/logo.png"



type AppIconProps = {
    className?: string
}

export const AppIcon = ({ className = "h-14 w-14" }: AppIconProps) => {
    const name = process.env.REACT_APP_NAME || "";

    return <>
        <div className={"flex  items-center justify-center rounded-full overflow-hidden  bg-primary " + className}>
            <img
                alt={name}
                src={appicon}
            />
        </div>
    </>
}